import React, { useState, useEffect } from "react";
import _ from "lodash";

import styles from "./styles.module.scss";
import DeleteIcon from "@material-ui/icons/Delete";
import Button from "../Button";
import GetAllCountries from "../GetAllCountries";
import { useNotification } from "../../context/notification";
import { useTranslation } from "react-i18next";

function AddCountries({ addedCountries, primaryCountry, list }) {
  const { t } = useTranslation();
  const { addNotification } = useNotification();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countries, setCountries] = useState(list);

  useEffect(() => {
    setCountries(list);
  }, [list]);

  useEffect(() => {
    addedCountries(countries);
  }, [countries]);

  //Delete countries
  const deleteCountry = country => {
    const remainingItems = [
      ...countries.filter(list => list.region_id !== country.region_id),
    ];
    setCountries(remainingItems);
  };

  //add country
  const addCountries = country => {
    if (
      _.find(countries, { region_id: country.id }) ||
      primaryCountry.id === country.id
    ) {
      addNotification(t("error.selectedCountryIsAlreadyInTheList"), "error");
    } else {
      const selectedCountry = { ...country, region_id: country.id };
      if (countries) {
        setCountries([...countries, selectedCountry]);
      } else {
        setCountries([selectedCountry]);
      }
    }
  };

  return (
    <>
      <div className={styles.profileRow}>
        <div className={styles.rowLeft}>Country</div>
        <div
          className={styles.rowRight}
          style={{
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <GetAllCountries
            countryChange={val => {
              setSelectedCountry(val);
            }}
            multi={true}
          />
          <Button
            variant="outlined"
            color="secondary"
            size="small"
            style={{ marginLeft: "6px" }}
            onClick={() => {
              addCountries(selectedCountry);
            }}
          >
            Add
          </Button>
        </div>
      </div>

      <div className={styles.profileRow}>
        <div className={styles.rowLeft}></div>
        <div className={styles.rowRight}>
          <div className={styles.campaignWrapper}>
            <div className={styles.campaignItem}>
              <div className={styles.selectedCampaign}>
                <span className={styles.count}>{1}</span>
                <h5 className={styles.campaignHead}>{primaryCountry.title}</h5>
                <span style={{ width: "15px" }}></span>
              </div>
            </div>
            {countries &&
              countries.map((item, index) => (
                <div key={index} className={styles.campaignItem}>
                  <div className={styles.selectedCampaign}>
                    <span className={styles.count}>{index + 2}</span>
                    <h5 className={styles.campaignHead}>{item.title}</h5>

                    <DeleteIcon
                      onClick={() => {
                        deleteCountry(item);
                      }}
                      style={{
                        color: "#9E9E9E",
                        fontSize: 16,
                        cursor: "pointer",
                        float: "right",
                      }}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default AddCountries;
